/**
 * Holds how long the sync engine's start-up routine took on this app launch,
 * so the Phone check page can show it. In memory only — never persisted.
 */
let startupSyncMs: number | null = null;

/** Records the start-up sync duration in milliseconds. */
export const recordStartupSyncMs = (ms: number): void => {
  startupSyncMs = ms;
};

/** Returns the start-up sync duration in milliseconds, or null if not measured. */
export const getStartupSyncMs = (): number | null => startupSyncMs;

/** Test-only: forget any recorded duration. */
export const __resetStartupTimingForTests = (): void => {
  startupSyncMs = null;
};
